import React, {Component} from 'react';
import styled from 'styled-components';

import {StyledPageCenterContainer, maxExtendedWidth} from '../../components/globalStyles';
import Layout from '../../components/layout';
import WhoIsUsingSection from '../../components/whoIsUsingSection';
import {CompanyName} from '../../data/customerData';

import DemosSection from './demosSection';
import ProductsSection from './productsSection';

const StyledLandingPageCenterContainer = styled(StyledPageCenterContainer)`
  > * {
    max-width: ${maxExtendedWidth};
  }
`;

class LandingPageView extends Component {
  public render() {
    return (
      <Layout>
        <StyledLandingPageCenterContainer>
          <ProductsSection />
          <DemosSection />
          <WhoIsUsingSection
            headline={'Our valued customers'}
            companies={[CompanyName.SlingTV, CompanyName.NewYorkTimes, CompanyName.BBC, CompanyName.Globo]}
          />
        </StyledLandingPageCenterContainer>
      </Layout>
    );
  }
}

export default LandingPageView;
